import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

type Segment = {
  label: string;
  value: number;
  color: string;
};

type CustomersStatusCounterChartProps = {
  data: Segment[];
  height?: number;
  radius?: number;
};

export const CustomersStatusCounterChart: FC<CustomersStatusCounterChartProps> = ({
  data,
  height = 8,
  radius = 20,
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height,
          borderRadius: radius,
          overflow: 'hidden',
          backgroundColor: 'grey.200',
        }}
      >
        {data.map((item) => (
          <Box
            key={item.label}
            sx={{
              width: `${(item.value / total) * 100}%`,
              backgroundColor: item.color,
              transition: 'width 0.3s ease',
            }}
          />
        ))}
      </Box>
      <Stack
        direction="row"
        sx={{
          gap: "20px",
          marginTop: 1,
          justifyContent: "flex-start"
        }}>
        {data.map((item) => (
          <Stack
            key={item.label}
            direction="row"
            sx={{
              gap: 1,
              alignItems: "center"
            }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '2px',
                backgroundColor: item.color,
              }}
            />
            <Typography variant="caption" sx={{
              fontSize: "14px"
            }}>
              {item.label}: <strong>{item.value}</strong>
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
